var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "w-full bg-light-purple-100 flex justify-center overflow-auto py-6",
      staticStyle: { height: "calc(100vh - 4.5rem)" }
    },
    [
      _c(
        "div",
        { staticClass: "bg-pure-white rounded-3xl w-200 h-min relative" },
        [
          _c(
            "div",
            {
              staticClass:
                "flex items-center gap-4 w-full pt-5 px-10 border-b border-grey-200"
            },
            [
              _c(
                "button",
                {
                  staticClass: "border-b-4 outline-none w-full text-center",
                  class:
                    _vm.tab === "profile"
                      ? "border-light-purple"
                      : "border-transparent",
                  on: {
                    click: function($event) {
                      return _vm.setTab("profile")
                    }
                  }
                },
                [_c("BlTextSubtitle2", { attrs: { text: "Profile" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "border-b-4 outline-none w-full text-center",
                  class:
                    _vm.tab === "session"
                      ? "border-light-purple"
                      : "border-transparent",
                  on: {
                    click: function($event) {
                      return _vm.setTab("session")
                    }
                  }
                },
                [_c("BlTextSubtitle2", { attrs: { text: "Session history" } })],
                1
              )
            ]
          ),
          _vm._v(" "),
          _vm.tab === "profile" ? _c("TabProfile") : _vm._e(),
          _vm._v(" "),
          _vm.tab === "session"
            ? _c("TabSession", {
                attrs: {
                  description:
                    "Here is detailed information about your session history.",
                  basePath: "/profile?tab=session",
                  userId: Number(_vm.currentUser.id)
                }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f2e67c3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f2e67c3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/Profile.vue
// module id = null
// module chunks = 